// Offer Comparison — API calls (transaction-service, via the gateway).
// Mirrors offerAiSummaryApi.js (same auth + base pattern).
import { onAuthStateChanged } from 'firebase/auth';
import { API_BASE_URL, apiClient } from '../../config/api';
import { auth } from '../../firebase/config';

const base = (transactionId) =>
  `${API_BASE_URL}/api/v1/transactions/${transactionId}/offer-comparison`;

const getFirebaseToken = () => new Promise((resolve, reject) => {
  if (auth.currentUser) {
    auth.currentUser.getIdToken(false).then(resolve).catch(reject);
    return;
  }
  const timer = setTimeout(() => reject(new Error('Auth timeout')), 10000);
  const unsub = onAuthStateChanged(auth, (user) => {
    unsub();
    clearTimeout(timer);
    if (user) user.getIdToken(false).then(resolve).catch(reject);
    else reject(new Error('Not authenticated'));
  });
});

const authHeaders = async () => ({ Authorization: `Bearer ${await getFirebaseToken()}` });

// GET returns the current comparison record. Server-side, if the inputHash is
// stale (new summary version, offer status change, new offer), the service
// claims PENDING and submits a regen job before responding — the client just
// sees PENDING and polls.
export const getOfferComparison = async (transactionId) => {
  const res = await apiClient.get(base(transactionId), { headers: await authHeaders() });
  return res.data;
};

// Unified entry — handles both first-time generation and regenerate. Plain
// POST at the base URL. Previously used :generate / :regenerate suffixes but
// Spring 6's PathPatternParser doesn't match literal colons in path segments
// (see controller note).
export const generateOfferComparison = async (transactionId) => {
  const res = await apiClient.post(base(transactionId), null, {
    headers: await authHeaders(),
  });
  return res.data;
};

// Alias kept so the modal's existing onRegenerate wire-up continues to work.
export const regenerateOfferComparison = generateOfferComparison;

export const errorMessage = (err, fallback) => {
  const status = err?.response?.status;
  const message = err?.response?.data?.message;
  if (status === 409) {
    return message || 'A comparison needs at least two purchase-agreement offers with summaries generated.';
  }
  if (status === 403) return "You don't have access to the offer comparison on this listing.";
  if (message && typeof message === 'string') return message;
  return fallback;
};
